import { Component } from "@angular/core";
import { FormBuilder } from "@angular/forms";

import * as moment from "moment";

import { ConectorProvider } from "../../providers/conector/conector";

import { NavController, NavParams, LoadingController } from "ionic-angular";

@Component({
  selector: "page-solicitudnueva",
  templateUrl: "solicitudnueva.html"
})
export class SolicitudnuevaPage {
  data: any = {};
  formulario: any;

  hoy: Date;
  fechaMin: any;
  esperandoRespuesta = false;
  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public formBuilder: FormBuilder,
    public conector: ConectorProvider,
    public loadingController: LoadingController
  ) {
    this.data = {
      background: "assets/images/background/39.jpg"
    };

    this.hoy = new Date();
    this.fechaMin = moment(new Date())
      .add(2, "days")
      .format("YYYY-MM-DD"); //Solicitudes como minimo a partir de 48 horas

    console.log("fechaMin", this.fechaMin);

    this.formulario = formBuilder.group({
      tipo: [""],
      fdesde: [""],
      fhasta: [""],
      descripcion: [""]
    });
  }

  ionViewDidLoad() {
    console.log("ionViewDidLoad SolicitudnuevaPage");
  }

  grabar() {
    console.log("bt grabar");
    console.log(this.formulario);
    this.esperandoRespuesta = true;
    const loader = this.loadingController.create({
      content: "Espere por favor...",
      duration: 6000
    });

    loader.present();
    this.conector
      .GuardarSolicitud(
        this.formulario.controls.tipo.value,
        this.formulario.controls.fdesde.value,
        this.formulario.controls.fhasta.value,
        this.formulario.controls.descripcion.value
      )
      .subscribe(data => {
        if (data["error"]) {
          this.conector.presentToast("Error al generar la solicitud");
          loader.dismiss();
          this.esperandoRespuesta = false;
        } else {
          this.conector.presentToast("La solicitud se generó con éxito");
          loader.dismiss();
          this.esperandoRespuesta = false;
          this.navCtrl.pop();
        }
        console.log("respuesta guardar solicitud", data);
      });
  }
}



// WEBPACK FOOTER //
// ./src/pages/solicitudnueva/solicitudnueva.ts